const VISIBLE_PORTFOLIOS = 4;
const VISIBLE_STAFFS = 3;

export { VISIBLE_PORTFOLIOS, VISIBLE_STAFFS };
